module.exports = __webpack_public_path__ + "img/calligraphy-work-icon4.5ba18571.jpg";